import { Calculator } from './components/Calculator';
import { Layout } from './components/Layout';
import { BuyMeCoffee } from './components/BuyMeCoffee';
import { Footer } from './components/Footer';
import { Helmet } from 'react-helmet-async';

function App() {
  return (
    <Layout>
      <Helmet>
        <title>CTC Calculator | Salary Breakdown for Indian Employees</title>
        <meta
          name="description"
          content="Calculate your take-home salary and understand your complete compensation structure. Free Indian salary calculator with tax benefits, HRA, and EPF calculations."
        />
        <meta name="keywords" content="CTC calculator, salary calculator india, take home salary, HRA calculator, EPF calculator, income tax calculator" />
        <link rel="canonical" href="https://www.ctccalculator.in/" />
        <meta name="robots" content="index,follow" />
      </Helmet>
      <header className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
          CTC Calculator
        </h2>
        <p className="text-gray-600">
          Calculate your take-home salary and understand your complete compensation structure
        </p>
      </header>
      
      <main>
        <Calculator />
      </main>
      
      <div className="mt-8 text-center">
        <BuyMeCoffee />
      </div>
      
      <Footer />
    </Layout>
  );
}

export default App;
